import { LocationType } from 'pages/my-calendars/enums'
import type { FlattenedData } from '../interfaces'

export const getFlattenArray = (data: FlattenedData, property: LocationType) => {
    const result = []

    if (property === LocationType.Region) {
        // Добавляем регион
        result.push({
            id: data.regionId,
            locationType: data.locationType
        })
    }
    // Проходим по всем кластерам
    data.clusters.map((cluster) => {
        // Добавляем кластер
        result.push({
            id: cluster.clusterId,
            locationType: cluster.locationType,
            parentId: data.regionId // Указываем родителя
        })

        // Проходим по всем магазинам кластера
        cluster.stores.map((store) => {
            // Добавляем магазин
            result.push({
                id: store.storeId,
                locationType: store.locationType,
                parentId: cluster.clusterId // Указываем родителя
            })
        })
    })

    return result
}
